import axios from 'axios'

export const getConfig = async () => {
  return await axios.get('api/misc/config')
}

